import {Injectable} from '@angular/core';
import {ManufacturingCategoryState, Store as ManufacturingCategoryStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {ManufacturingCategory} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {ManufacturingCategoryQuery} from './query';

@Injectable({ providedIn: 'root' })
export class ManufacturingCategoryService extends EntityService<ManufacturingCategoryStore, ManufacturingCategoryState> {

  manufacturingCategories$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new ManufacturingCategory(item)).sort((u1, u2) => u1.toString() > u2.toString() ? 1 : -1)),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('manufacturingCategory.entityTitle'),
    fields: [
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('manufacturingCategory.name'),
        inputType: 'text',
        name: 'name',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: ManufacturingCategoryQuery,
    protected store: ManufacturingCategoryStore) {
    super(store, ManufacturingCategory);
  }

  get resourceName(): string {
    return 'products/manufacturing-category';
  }

}
